import {CommonContainerConst} from '@multipass-common';
import {Router} from '@multipass-system';
import {Module, ModuleBuilder} from 'esp-js-ui';

import {NAVIGATION_STORE_ID, registerNavigationStore, ShellRouteHandler} from './logic';
import {ActivePageView, RegionNames} from './views';

export const createNavigationModule = (): Module =>
    ModuleBuilder.create('navigation')
        .withView(NAVIGATION_STORE_ID, ActivePageView, RegionNames.main)
        .withInitialisation(async app => {
            const router = app.container.resolve<Router>(CommonContainerConst.router);
            registerNavigationStore(app.eventBus, router);
            new ShellRouteHandler(router, app.eventBus).registerRoutes();
        })
        .build();
